module.exports = __webpack_public_path__ + "img/Mask-Group-480.959f7e92.png";